<template>
<svg xmlns="http://www.w3.org/2000/svg" :fill="useCurrentColor ? 'currentColor' : '#000'" viewBox="0 0 48 48" :class="[`${prefix}-icon`, `${prefix}-icon-Reduce`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_cdf1249b48__a"><rect width="48" height="48" rx="0"/></clipPath></defs><g clip-path="url(#svg_cdf1249b48__a)"><path d="M23.9583,5C34.4287,5,42.9167,13.48792,42.9167,23.9583C42.9167,34.4287,34.4287,42.9167,23.9583,42.9167C13.48792,42.9167,5,34.4287,5,23.9583C5,13.48792,13.48792,5,23.9583,5ZM23.9583,8.25C15.283,8.25,8.25,15.283,8.25,23.9583C8.25,32.633700000000005,15.283,39.6667,23.9583,39.6667C32.633700000000005,39.6667,39.6667,32.633700000000005,39.6667,23.9583C39.6667,15.283,32.633700000000005,8.25,23.9583,8.25ZM31.4063,22.121C32.2708,22.122,32.9831,22.7996,33.0273,23.663C33.0714,24.5264,32.4319,25.2732,31.572,25.3623L31.4063,25.371L16.5104,25.371C15.6459,25.37,14.93354,24.6923,14.88939,23.829C14.84524,22.9656,15.4848,22.2188,16.3447,22.1297L16.5104,22.121L31.4063,22.121Z"/></g></svg>
</template>
<script>

export default {
  name: 'IconReduce',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
